<template>
  <div class="loading-state d-flex flex-column align-items-center justify-content-center text-center py-4">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">در حال بارگذاری...</span>
    </div>
    <p v-if="message" class="mt-3 mb-0 text-secondary">{{ message }}</p>
  </div>
</template>

<script lang="ts">
export default {
  name: "LoadingSpinner",
  props: {
    message: {
      type: String,
      default: "در حال بارگذاری...",
    },
  },
};
</script>

<style scoped>
.loading-state {
  width: 100%;
  min-height: 120px;
}
</style>
